// 操作ログタブの純ロジック（表示写像・reason 分解・クエリ構築）。
// ラベルは 2026-08 の機能文言確定で fix 済み。

export const operationLogActionFilters = [
  "shipment_import",
  "shipment_register",
  "shipment_acceptance",
  "hold",
  "skip",
  "release",
  "return",
  "refund",
  "refund_failed",
  "refund_skipped",
  "admin_role_granted",
  "admin_role_revoked",
  "admin_stock_hold_skipped",
] as const;

const actionLabels: Record<string, string> = {
  shipment_import: "追跡番号取込",
  shipment_register: "追跡番号登録",
  shipment_acceptance: "引受記録",
  hold: "災害停止",
  skip: "回スキップ",
  release: "停止解除",
  return: "未受取終了",
  refund: "返金",
  refund_failed: "返金失敗",
  refund_skipped: "返金スキップ",
  admin_role_granted: "管理者付与",
  admin_role_revoked: "管理者剥奪",
  admin_stock_hold_skipped: "在庫不足スキップ",
};

export function formatOperationAction(action: string): string {
  return actionLabels[action] ?? action;
}

export type OperationActionBadgeVariant =
  | "default"
  | "secondary"
  | "destructive"
  | "warning"
  | "outline";

// 破壊度で色分け: 返金・剥奪・未受取終了 = destructive、
// 停止系 = warning、記録系 = secondary。
export function operationActionBadgeVariant(
  action: string,
): OperationActionBadgeVariant {
  switch (action) {
    case "refund":
    case "refund_failed":
    case "return":
    case "admin_role_revoked":
      return "destructive";
    case "hold":
    case "skip":
    case "refund_skipped":
    case "admin_stock_hold_skipped":
      return "warning";
    case "shipment_import":
    case "shipment_register":
    case "shipment_acceptance":
    case "release":
      return "secondary";
    default:
      return "outline";
  }
}

const targetTypeLabels: Record<string, string> = {
  subscription: "定期契約",
  cycle: "お届け回",
  one_time_order: "単品注文",
  admin_user: "管理者",
  shipment: "出荷",
};

export function formatOperationTargetType(targetType: string): string {
  return targetTypeLabels[targetType] ?? targetType;
}

export interface ParsedOperationReason {
  batchRef: string | null;
  note: string | null;
}

// reason 先頭の `batch:<uuid>` マーカー（A3 設計の束ね規約）を分離する。
const batchMarkerPattern = /^batch:([0-9a-f-]{36})(?:\s+(.*))?$/i;

export function parseOperationReason(
  reason: string | null,
): ParsedOperationReason {
  if (!reason) {
    return { batchRef: null, note: null };
  }
  const match = batchMarkerPattern.exec(reason);
  if (!match) {
    return { batchRef: null, note: reason };
  }
  return {
    batchRef: match[1] ?? null,
    note: match[2]?.trim() || null,
  };
}

export function buildOperationLogsQuery(filter: {
  action?: string;
}): string {
  const params = new URLSearchParams();
  if (filter.action) {
    params.set("action", filter.action);
  }
  const query = params.toString();
  return query ? `?${query}` : "";
}
